import { cx } from 'linaria';
import * as React from 'react';

import { states, Typography } from '../index';
import * as styles from './switch.styles';
import { SwitchProps } from './switch.types';

import { useControlledState } from '../hooks/use-controlled-state';
import { useId } from '../hooks/use-id';

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => {
    const {
        value: controlledValue,
        defaultValue = false,
        onChange: controlledOnChange,
        name,
        disabled = false,
        size = 'medium',
        label,
        testId,
        className,
        ...passThroughProps
    } = props;

    const [value, onChange] = useControlledState(controlledValue, defaultValue, controlledOnChange);

    const switchId = useId();
    const labelId = useId();

    const handleClick = () => {
        onChange(!value);
    };

    const handleKeydown = (event: React.KeyboardEvent) => {
        if (event.code === 'Space' || event.code === 'Enter') {
            onChange(!value);
        }
    };

    return (
        <div className={cx(styles.root, className)}>
            <button
                {...passThroughProps}
                ref={ref}
                role="switch"
                aria-checked={value}
                onClick={handleClick}
                onKeyDown={handleKeydown}
                className={cx(styles.switchElement, styles.sizes[size], states)}
                disabled={disabled}
                name={name}
                value={value ? 'on' : 'off'}
                data-testid={testId}
                id={switchId}
                aria-labelledby={labelId}
            ></button>

            <Typography as="label" variant="label-1" id={labelId} htmlFor={switchId} className={styles.label}>
                {label}
            </Typography>
        </div>
    );
});

Switch.displayName = 'Switch';
